import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { AuthStateService } from '../shared/auth-state.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    styleUrls: ['./app.menu.component.css'],
})
export class AppMenuComponent implements OnInit {
    model: any[] = [];

    partnerInfo!: String;

    constructor(
        public layoutService: LayoutService,
        private authStateService: AuthStateService,
        private router: Router
    ) { }

    ngOnInit() {
        this.model = [
            {
                items: [
                    {
                        label: 'Partners',
                        icon: 'bi bi-briefcase',
                        routerLink: ['/home/partners'],
                        permission: 'manage_partners',
                    },
                    {
                        label: 'Motor Insurance',
                        icon: 'pi pi-car',
                        routerLink: ['/home/search'],
                        permission: 'manage_customers',
                    },
                    {
                        label: 'Vehicle Breakdown Insurance',
                        icon: 'bi bi-tools',
                        routerLink: ['/home/motor-plan'],
                        permission: 'manage_customers',
                    },
                    {
                        label: 'SME Coupons',
                        icon: 'bi bi-shop',
                        routerLink: ['/home/sme-search'],
                        permission: 'manage_customers',
                    },
                    {
                        label: 'Legal Aid',
                        icon: 'bi bi-bank',
                        routerLink: ['/home/legal-aid'],
                        permission: 'manage_customers',
                    },
                    {
                        label: 'Burial Assistance',
                        icon: 'bi bi-flower1',
                        routerLink: ['/home/burial-assistance'],
                        permission: 'manage_customers',
                    },
                    {
                        label: 'Hospital Cashback',
                        icon: 'bi bi-hospital',
                        routerLink: ['/home/hospital-cashback'],
                        permission: 'manage_customers',
                    },
                    {
                        label: 'Home Insurance',
                        icon: 'bi bi-house-lock',
                        routerLink: ['/home/home-insurance'],
                        permission: 'manage_customers',
                    }
                    ,
                    {
                        label: 'Claims Management',
                        icon: 'bi bi-file-earmark-medical',
                        routerLink: ['/home/home-insurance/claims'],
                        permission: 'report_claims',
                    },
                    {
                        label: 'Users',
                        icon: 'bi bi-person-badge',
                        routerLink: ['/home/users'],
                        permission: 'manage_users',
                    },
                    {
                        label: 'Insure Spin and Win',
                        icon: 'pi pi-gift',
                        routerLink: ['/home/promotions'],
                        permission: 'promotions',
                    },
                    {
                        label: 'Reports',
                        icon: 'bi bi-clipboard-data',
                        routerLink: ['/home/reports'],
                        permission: 'manage_customers',
                    },
                    {
                        label: 'Icecash Reports',
                        icon: 'bi bi-file-earmark-excel',
                        routerLink: ['/home/icecash-reports'],
                        permission: 'icecash_bulk_uploads',
                    },
                    {
                        label: 'Whatsapp Broadcasts',
                        icon: 'bi bi-whatsapp',
                        routerLink: ['/home/whatsapp-broadcasts'],
                        permission: 'whatsapp_broadcasts',
                    },
                    {
                        label: 'Face Value',
                        icon: 'pi pi-file-export',
                        permission: 'can_manage_fvd_stock',
                        items: [
                            {
                                label: 'Face Value Management',
                                icon: 'pi pi-file-export',
                                routerLink: ['/home/face-value-documents'],
                                permission: 'can_manage_fvd_stock',
                            },
                            {
                                label: 'Face Value Usage',
                                icon: 'pi pi-file',
                                routerLink: ['/home/face-value-usages'],
                                permission: 'can_report_fvd_stock_usage',
                            },
                            {
                                label: 'Face Value Recall',
                                icon: 'pi pi-replay',
                                routerLink: ['/home/face-value-documents/recall-stock'],
                                permission: 'can_manage_fvd_stock',
                            },
                        ]
                    },
                    {
                        label: 'Comprehensive Approvals',
                        icon: 'pi pi-verified',
                        routerLink: ['/home/comprehensive-approvals'],
                        permission: 'manage_customers',
                    },
                    {
                        label: 'Bank Reconciliations',
                        icon: 'pi pi-credit-card',
                        permission: 'manage_customers',
                        items: [
                            {
                                label: 'Reconciliations',
                                icon: 'pi pi-credit-card',
                                routerLink: ['/home/bank-reconciliations'],
                                permission: 'manage_customers',
                            },
                            {
                                label: 'POS Config',
                                icon: 'pi pi-cog',
                                routerLink: ['/home/pos-config'],
                                permission: 'manage_customers',
                            },
                            {
                                label: 'Bank Management',
                                icon: 'pi pi-building',
                                routerLink: ['/home/bank-management'],
                                permission: 'manage_customers',
                            },
                            {
                                label: 'Sales Upload',
                                icon: 'pi pi-upload',
                                routerLink: ['/home/sales-upload'],
                                permission: 'manage_customers',
                            }
                        ]
                    }
                ],
            },
        ];
        this.partnerInfo = this.getUserPartnerAndBranch();
    }

    getUserPartnerAndBranch(): string {
        return this.authStateService.getAuthTokenInfo().partner &&
            this.authStateService.getAuthTokenInfo().partner_branch
            ? this.authStateService.getAuthTokenInfo().partner +
            '  |  ' +
            this.authStateService.getAuthTokenInfo().partner_branch
            : '-- | --';
    }

    hasPermission(permission: string): boolean {
        return this.authStateService.checkUserPermission(permission);
    }
}
